import { Box, Stack, Text } from '@chakra-ui/react';
import { SlotCard } from './SlotCard';

export const EnrollmentList = ({
	lessonList,
	onRemove,
	onUpdate,
	actionType = 'none',
}: {
	lessonList: any[];
	onRemove?: (index: number) => void;
	onUpdate?: (index: number, nextNotes: string) => void;
	actionType?: 'add' | 'remove' | 'none';
}) => {
	const effectiveActionType = onRemove ? actionType : 'none';
	const canEditNotes = Boolean(onUpdate) && effectiveActionType !== 'none';
	const grouped = lessonList.reduce<Record<string, { lesson: any; index: number }[]>>((acc, lesson, index) => {
		const studentName = lesson?.student?.name || 'Brak uczestnika';
		if (!acc[studentName]) {
			acc[studentName] = [];
		}
		acc[studentName].push({ lesson, index });
		return acc;
	}, {});

	return (
		<Stack gap={4}>
			{Object.entries(grouped).map(([studentName, lessons]) => (
				<Box key={studentName}>
					<Text fontWeight="semibold" mb={2}>{studentName}</Text>
					<Stack gap={0}>
						{lessons.map(({ lesson, index }) => (
							<SlotCard
								key={`${studentName}-${index}`}
								slot={lesson}
								actionType={effectiveActionType}
								showSlotCode
								onClick={() => onRemove?.(index)}
								onNoteChange={canEditNotes ? (nextNotes: string) => onUpdate?.(index, nextNotes) : undefined}
							/>
						))}
					</Stack>
				</Box>
			))}
		</Stack>
	);
};
